import gql from 'graphql-tag';

const NAME = 'compositions_CaseInboundProgramPanel_allInboundProgramsQuery';

export default gql`
  query ${NAME} {
    inboundProgramNumbers {
      inboundPrograms {
        id
        accountType {
          id
          name
        }
        customerName
        tollFreeNumber
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseInboundProgramPanel/withFilteredInboundPrograms/allInboundProgramsQuery.js